import type {ReactElement} from 'react';

import IconButton from '@mui/material/IconButton/IconButton.js';
import Dialog from '@mui/material/Dialog/Dialog.js';
import DialogActions from '@mui/material/DialogActions/DialogActions.js';
import DialogContent from '@mui/material/DialogContent/DialogContent.js';
import DialogTitle from '@mui/material/DialogTitle/DialogTitle.js';
import CloseIcon from '@mui/icons-material/Close.js';

import './CustomDialog.css';

export default function CustomDialog(props: {
    onClose?: () => void;
    title?: string;
    content?: ReactElement;
    action?: ReactElement;
    displayCloseButton?: boolean;
    isCentered?: boolean;
    className?: string;
}): ReactElement {
    return (
        <Dialog
            className={`custom-modal ${props.isCentered ? 'center' : ''} ${props.className}`}
            open={true}
            onClose={props.onClose}
        >
            {props.displayCloseButton && (
                <div className="custom-dialog-close">
                    <IconButton className="custom-dialog-close-button" onClick={props.onClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
            )}
            {props.title && <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>}
            {props.content && <DialogContent>{props.content}</DialogContent>}
            {props.action && <DialogActions>{props.action}</DialogActions>}
        </Dialog>
    );
}
